/**
 * 班级荣誉 API（班牌荣誉管理）
 * 后端接口：/api/class-honors
 */
import { request } from './request'

function buildQuery(params) {
  const search = new URLSearchParams()
  Object.entries(params || {}).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') search.set(k, v)
  })
  const qs = search.toString()
  return qs ? `?${qs}` : ''
}

/**
 * 获取班牌荣誉列表（分页）
 * @param {object} params - { class_id?, title?, page?, page_size? }
 */
export function getClassHonors(params) {
  return request(`/api/class-honors${buildQuery(params)}`)
}

/**
 * 根据 ID 获取班牌荣誉详情
 */
export function getClassHonor(id) {
  return request(`/api/class-honors/${id}`)
}

/**
 * 根据班级 ID 获取荣誉列表（不分页）
 */
export function getClassHonorsByClass(classId) {
  return request(`/api/class-honors/class/${classId}`)
}

/**
 * 创建班牌荣誉
 * @param {object} data - { class_id, type, title, file_url?, description?, honor_date? }
 * type: 0=文字, 1=图片
 */
export function createClassHonor(data) {
  return request('/api/class-honors', {
    method: 'POST',
    body: JSON.stringify(data)
  })
}

/**
 * 更新班牌荣誉
 * @param {string|number} id - 荣誉 ID
 * @param {object} data - { title?, description?, honor_date?, update_by? }
 */
export function updateClassHonor(id, data) {
  return request(`/api/class-honors/${id}`, {
    method: 'PUT',
    body: JSON.stringify(data)
  })
}

/**
 * 删除班牌荣誉
 */
export function deleteClassHonor(id) {
  return request(`/api/class-honors/${id}`, {
    method: 'DELETE'
  })
}
